module.exports = __webpack_public_path__ + "img/16.7.Chla.73ae30e2.png";